import React, { Component } from "react";
import { App } from "../../App";
import { AppScreen } from "../../AppScreen";
import landingFooterImage from "../../assets/images/landing-footer.png";
import landingSun from "../../assets/images/sun.png";
import { CloseButton } from "../components/CloseButton";

export interface IFrameScreenProps
{
}

interface IFrameScreenState 
{
    loading: boolean;
}

export class IFrameScreen extends Component<IFrameScreenProps, IFrameScreenState>
{
    private iframeRef: React.RefObject<HTMLIFrameElement> = null;

    constructor(props: IFrameScreenProps)
    {
        super(props);

        this.iframeRef = React.createRef();

        this.state = {
            loading: true
        };
    }

    public componentDidMount(): void
    {
        this.iframeRef.current.src = App.I.iframeUrl;
        this.iframeRef.current.onload = this.onLoadComplete.bind(this);
    }

    private onLoadComplete(): void 
    {
        this.setState({
            loading: false
        });
    }

    private onCloseIFrameClicked(): void 
    {
        App.I.changeScreen(AppScreen.ParentZone);
    }

    public render(): JSX.Element
    {
        return (
            <>
                {this.state.loading ?
                    <div className="loading">
                        <div className="landing-screen">
                            <div className="sun">
                                <img src={landingSun} alt="Sun" />
                            </div>
                            <div className="container">
                                <div className="landing-container">

                                    <h2 className="sub-title text-uppercase text-center">
                                        Loading, please wait
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
                }

                <div className="header">
                    <CloseButton onClicked={this.onCloseIFrameClicked.bind(this)} />
                </div>

                <div className="iframe-screen">
                    <iframe ref={this.iframeRef} width="100%" height="100%"></iframe>
                </div>
            </>
        );
    }
}